<script setup lang="ts">
import { NewsCategoryBlockProps } from "./NewsCategoryBlock.props"

defineProps<NewsCategoryBlockProps>()
</script>

<template>
  <ProductBlocksBrandsGridCardsBlock :title="title" :cards="cards" />
</template>
